<template>
  <generic-modal
    :title="$t('replacement parts')"
    ref="generic_modal"
    :is_wide="true"
  >
    <div class="tabs is-toggle is-fullwidth" ref="tabs">
      <ul>
        <li
          class="is-active"
          data-tab="list"
          @click="change_active_tab($event, this)"
        >
          <a>
            <i class="list icon" aria-hidden="true"></i>
            <span>{{ $t("list") }}</span>
          </a>
        </li>
        <li data-tab="pics" @click="change_active_tab($event, this)">
          <a>
            <i class="camera icon" aria-hidden="true"></i>
            <span>{{ $t("pictures") }}</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="is-fluid" ref="contents">
      <div class="" data-tab="list">
        <!-- <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("date") }}</label>
              <div class="control">
                <input
                  class="input"
                  type="datetime-local"
                  v-model="meta.date"
                />
              </div>
            </div>
          </div>
          <div class="column is-two-thirds">
            <div class="field">
              <label class="label">{{ $t("part") }}</label>
              <div class="control">
                <input class="input" type="text" v-model="meta.part" />
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("quantity") }}</label>
              <div class="control">
                <input class="input" type="number" v-model="meta.quantity" />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("price") }}</label>
              <div class="control">
                <input class="input" type="number" v-model="meta.price" />
              </div>
            </div>
          </div>
          <div class="column is-two-thirds">
            <div class="field">
              <label class="label">{{ $t("comment") }}</label>
              <div class="control">
                <textarea
                  class="textarea"
                  rows="2"
                  v-model="meta.comment"
                ></textarea>
              </div>
            </div>
          </div>
        </div> -->
        <div
          class="button is-rounded is-primary is-pulled-right"
          @click="add_replacement"
        >
          <span class="icon">
            <i class="fa fa-plus"></i>
          </span>
          <span>{{ $t("add") }}</span>
        </div>
        <div class="title is-5">
          {{ $t("replacement parts list") }}
        </div>
        <table class="table is-fullwidth">
          <thead>
            <tr>
              <th>{{ $t("date") }}</th>
              <th>{{ $t("part") }}</th>
              <th>{{ $t("quantity") }}</th>
              <th>{{ $t("price") }}</th>
              <th>{{ $t("comment") }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, idx) in meta.list" :key="idx">
              <td>
                <input class="input" type="date" v-model="item.date" />
              </td>
              <td>
                <input class="input" type="text" v-model="item.part" />
              </td>
              <td>
                <input class="input" type="number" v-model="item.quantity" />
              </td>
              <td>
                <input class="input" type="number" v-model="item.price" />
              </td>
              <td>
                <input class="input" type="text" v-model="item.comment" />
              </td>
              <td>
                <div class="button is-small" @click="remove_replacement(idx)">
                  <span class="icon has-text-danger">
                    <i class="fa fa-trash"></i>
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="title is-5">
          {{ $t("total") }}: {{ format_currency(total_replacements) }}
        </div>
      </div>
      <div class="is-hidden" data-tab="pics">
        <div class="field">
          <label class="label">{{ $t("comment") }}</label>
          <div class="control">
            <textarea
              class="textarea"
              rows="2"
              v-model="meta.comment"
            ></textarea>
          </div>
        </div>
        <div class="field">
          <div class="control">
            <generic-uploader
              ref="revision_uploader"
              :idle_label="$t('drop photos here')"
              endpoint_url="/eserman/event/photo"
              @error="error_uploading"
              @success="success_uploading_revision"
              :allow_multiple="true"
            />
          </div>
        </div>

        <div class="grid is-col-min-7" v-if="meta.settings">
          <div
            class="cell"
            v-for="(photo, pidx) in meta.settings.revision_photos"
            :key="pidx"
          >
            <div class="card">
              <div class="card-image">
                <figure class="image is-128x128 m-auto py-3">
                  <v-lazy-image
                    :src="`${api_host}/drive/static/${photo.final_name}`"
                  />
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-content">
                    <!-- <p class="subtitle is-7 has-text-centered">
                  {{ photo.file }}
                </p> -->
                    <p class="subtitle is-7 has-text-centered">
                      {{ photo.description }}
                    </p>
                  </div>
                </div>
              </div>
              <footer class="card-footer">
                <div
                  class="button is-secondary card-footer-item"
                  @click="remove_revision_photo(pidx)"
                  :data-tooltip="$t('delete')"
                >
                  <span class="icon">
                    <i class="fa fa-trash"></i>
                  </span>
                  <!-- <span>{{ $t("delete") }}</span> -->
                </div>
                <div
                  class="button is-secondary card-footer-item"
                  @click="describe_revision_photo(photo)"
                  :data-tooltip="$t('describe')"
                >
                  <span class="icon">
                    <i class="fa fa-edit"></i>
                  </span>
                </div>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  del,
  get,
  post,
  error_alert,
  api_host,
  input_alert,
  generate_error_message_text,
  get_currency_settings,
  confirm_deletion_dialog,
  format_currency,
  format_date,
  change_active_tab,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import moment from "moment";
import { v4 } from "uuid";
import VLazyImage from "v-lazy-image";

export default {
  name: "ReplacementModal",
  components: { GenericModal, GenericCalendar, GenericUploader, VLazyImage },
  data() {
    let v = this;
    return {
      api_host,
      service_uuid: "",
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      return false;
      // return !v.meta.date || !v.meta.customer;
    },
    total_replacements() {
      let v = this;
      let total = 0;
      if (v.meta.list)
        total = v.meta.list.reduce((acc, item) => {
          return acc + Number(item.price);
        }, 0);
      return total;
    },
  },
  methods: {
    change_active_tab,
    moment,
    format_date,
    format_currency,
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let data = { ...v.meta, service_uuid: v.service_uuid };
      post("/mechanix/service/replacement", data)
        .then((r) => {
          v.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {},
        list: [],
      };
      v.service_uuid = "";
      v.error = "";
      v.$refs.revision_uploader.clear();
      v.meta.date = moment().format("YYYY-MM-DDTHH:mm");
      // v.$refs.generic_uploader.clear();
    },
    edit_modal(event_uuid) {
      let v = this;
      v.set_initial_state();
      v.service_uuid = event_uuid;
      get("/mechanix/service/replacement", { uuid: event_uuid })
        .then((data) => {
          if (data) v.meta = data;
        })
        .catch((error) => {
          console.error("error", error);
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$refs.generic_modal.show_modal();
        });
    },
    error_uploading(error) {
      let v = this;
      v.error = generate_error_message_text(error);
    },
    success_uploading(response) {
      let v = this;
      // v.$refs.generic_uploader.clear();
      let rspnse = JSON.parse(response.serverId);
      // let data = {
      //   file_id: rspnse.file.file_id,
      //   final_name: rspnse.final_name,
      // };

      if (v.meta.settings.photos) v.meta.settings.photos.push(rspnse);
      else v.meta.settings.photos = [rspnse];
    },
    success_uploading_revision(response) {
      let v = this;
      let rspnse = JSON.parse(response.serverId);
      if (v.meta.settings.revision_photos)
        v.meta.settings.revision_photos.push(rspnse);
      else v.meta.settings.revision_photos = [rspnse];
    },
    remove_revision_photo(index) {
      let v = this;
      confirm_deletion_dialog(v.$t("are you sure to delete photo?"), v, () => {
        v.meta.settings.revision_photos.splice(index, 1);
      });
    },
    describe_revision_photo(photo) {
      let v = this;
      let options = {
        input: "textarea",
        title: v.$t("describe photo"),
        input_value: photo.description,
        placeholder: v.$t("description"),
        confirm_text: v.$t("save"),
        cancel_text: v.$t("cancel"),
      };
      input_alert(options).then((value) => {
        photo.description = value;
      });
    },
    add_replacement() {
      let v = this;
      if (!v.meta.list) v.meta.list = [];
      v.meta.list.push({
        date: "",
        part: "",
        quantity: 1,
        price: 0,
        comment: "",
      });
    },
    remove_replacement(index) {
      let v = this;
      v.meta.list.splice(index, 1);
    },
  },
  created() {},
  watch: {},
};
</script>
<style></style>
